import { Button, OptionTile } from "@manifesthhqinc/ui-library";
import Footer from "../../../components/footer";
import TransitionWrapper from "../../../components/transition-wrapper/TransitionWrapper";
import ScrollableContainer from "../../../layout/scrollable-container";
import { UseHenryQuestionniareProps } from "../useHenryQuestionnaire";
import { BodyLargeRegular, ButtonText, HeadlineMedium, TitleMedium } from "../../../components/font";
import Container from "../../../layout/container";
import { FirstOptionContainer, SecondOptionContainer } from "./styles";
import { TransferOptionValues } from "../../../utils/getTransferOptionContent";
import HeadingContainer from "../../../layout/heading-container";
import { STEP_DESTINATION_METHODOLOGY_SCREEN } from "../../../class/transferDetails";

const HenryQuestionniareResult = (props: UseHenryQuestionniareProps) => {
  const {
    transferOptionContent,
    selectedTransferOption,
    setSelectedTransferOption,
    onConfirmSelectOption,
    onClickRestart,
    goToScreen,
  } = props;
  return (
    <TransitionWrapper>
      <ScrollableContainer name="henry-questionnaire-form-result">
        <Container>
          <HeadingContainer paneVariant="form" withProgressBar>
            <HeadlineMedium>Here’s your best option</HeadlineMedium>
            <BodyLargeRegular $textAlign="center" $maxWidth="300px">
              Manifest uses your answers to suggest the best option.{" "}
              <ButtonText onClick={() => goToScreen(STEP_DESTINATION_METHODOLOGY_SCREEN)}>Learn more</ButtonText>
            </BodyLargeRegular>
          </HeadingContainer>
          {transferOptionContent?.FIRST && transferOptionContent.FIRST.value && (
            <FirstOptionContainer>
              <OptionTile
                isSelected={selectedTransferOption === transferOptionContent.FIRST.value}
                className="bridge-hereiswhy-option-tile"
                isHenry
                isHereIsWhy
                supportingText={transferOptionContent?.FIRST?.description}
                hereIsWhyContent={transferOptionContent?.FIRST?.hereIsWhyContent}
                onChange={() =>
                  setSelectedTransferOption(transferOptionContent?.FIRST?.value || TransferOptionValues.noOption)
                }
              >
                {transferOptionContent?.FIRST?.title}
              </OptionTile>
            </FirstOptionContainer>
          )}
          {transferOptionContent?.SECOND && transferOptionContent.SECOND.value && (
            <SecondOptionContainer>
              <TitleMedium $textAlign="center" color="#000000">
                Second option:
              </TitleMedium>
              <OptionTile
                isSelected={selectedTransferOption === transferOptionContent.SECOND.value}
                className="bridge-hereiswhy-option-tile"
                onChange={() =>
                  setSelectedTransferOption(transferOptionContent?.SECOND?.value || TransferOptionValues.noOption)
                }
              >
                {transferOptionContent?.SECOND?.title}
              </OptionTile>
            </SecondOptionContainer>
          )}
        </Container>
      </ScrollableContainer>

      <Footer>
        <Button
          size="large"
          onClick={onConfirmSelectOption}
          disabled={selectedTransferOption === TransferOptionValues.noOption || !selectedTransferOption}
          name="continue"
        >
          Continue
        </Button>
        <Button variant="text" className="secondary-cta" onClick={onClickRestart}>
          Start over
        </Button>
      </Footer>
    </TransitionWrapper>
  );
};
export default HenryQuestionniareResult;
